$(function () {
  //WHen you click on reviews/write review or questions, bootstrap
  // opens the tab and this scrolls you to the content.
  // Delegated so the handlers survive the sku info AJAX refresh.
  $(document).on("click", ".TurnToReviewsTeaser", function () {
    let reviewTab = document.getElementById('reviews-content');
    const reviewCollapse = new bootstrap.Collapse(reviewTab, {
      toggle: false
    });
    reviewCollapse.show();
    reviewTab.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start'
    });
  });
  $(document).on("click", ".write-review__ask", function () {
    let questionsTab = document.getElementById('questions-content');
    const questionsCollapse = new bootstrap.Collapse(questionsTab, {
      toggle: false
    });
    questionsCollapse.show();
    questionsTab.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start'
    });
  });
  let dkTurnTo = new DK.TurnTo(dkTurnToConfiguration, dkTurnToConfiguration.ttProductId);
  // Set the dkTurnTo instance onto the window so that it can be reused
  window.DK.TurnTo.instance = dkTurnTo;

  // Load script tags after page has been rendered
  if (document.readyState === 'complete') {
    dkTurnTo.addScriptTags.bind(dkTurnTo)();
  } else {
    window.addEventListener('load', dkTurnTo.addScriptTags.bind(dkTurnTo), false);
  }
  if (window.location.hash === '#write-review') {
    // Scroll to the reviews section and open the Write a Review feature
    let turnToExists = window.setInterval(function () {
      if (typeof TurnTo != 'undefined') {
        dkTurnTo.writeReview();
        window.clearInterval(turnToExists);
      }
    }, 100);
  }
});
(function ($, window, undefined) {
  window.DK = window.DK || {};
  window.DK.TurnTo = TurnTo;
  function TurnTo(config, reviewId) {
    const self = this;
    self.turnToConfig = {
      sku: config.sku,
      locale: config.locale,
      pageId: config.pageId,
      site: config.site,
      siteKey: config.siteKey,
      staticEmbedBaseUrl: config.staticEmbedBaseUrl,
      reviewId: reviewId,
      reviewsSetupType: 'staticEmbed',
      setupType: 'staticEmbed',
      insertRelatedContentOnLoad: true,
      eventHandlers: {
        questionSubmit: self.turnToInvalidateQACache.bind(self),
        answerSubmit: self.turnToInvalidateQACache.bind(self),
        reviewSubmit: self.turnToInvalidateReviewCache.bind(self)
      },
      gallery: config.gallery
    };
    window.TurnToItemSku = reviewId;
    window.turnToConfig = self.turnToConfig;
  }
  DK.TurnTo.prototype.writeReview = function () {
    if (typeof TurnTo != 'undefined' && TurnTo.writeReview) {
      TurnTo.writeReview();
    }
  };

  // Re-renders the TurnTo widgets after their containers have been
  // replaced (e.g. the product tabs are reloaded via AJAX).
  DK.TurnTo.prototype.refresh = function (reviewId) {
    if (!reviewId || reviewId === this.turnToConfig.sku) {
      return;
    }
    this.turnToConfig.reviewId = reviewId;
    this.turnToConfig.sku = reviewId;
    window.TurnToItemSku = reviewId;
    if (typeof TurnToCmd === 'function') {
      TurnToCmd('set', {
        sku: reviewId
      });
    }
  };
  DK.TurnTo.prototype.turnToInvalidateCache = function (cacheType) {
    let xhr = new XMLHttpRequest();
    // Even though the reviews are at the product level, the
    // ProductReviewService takes the Sku to insulate us from
    // future changes to where reviews/Q&A are stored.
    let url = `/product/review-cache?productId=${this.turnToConfig.reviewId}
		&cacheType=${cacheType}`;
    xhr.open('POST', url, true);
    xhr.send();
  };
  DK.TurnTo.prototype.turnToInvalidateQACache = function () {
    this.turnToInvalidateCache('qa');
  };
  DK.TurnTo.prototype.turnToInvalidateReviewCache = function () {
    this.turnToInvalidateCache('review');
  };
  DK.TurnTo.prototype.addScriptTags = function () {
    let tt = document.createElement('script');
    tt.type = 'text/javascript';
    tt.async = true;
    tt.src = `https://widgets.turnto.com/v5/widgets/${this.turnToConfig.siteKey}
		/js/turnto.js`;
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(tt, s);
  };
})(window.jQuery, window);